module.exports = __webpack_public_path__ + "media/images/sites/health/f-estatisticas-e1b08e0ef4f047b8c283b18a3246322d.jpg";